import { Link } from 'react-router-dom';
import type { ProductSummary } from '@/api/types';
import { formatWon, stars } from '@/utils/format';

export default function ProductCard({ product }: { product: ProductSummary }) {
  const discounted = product.discountPrice != null && product.discountRate > 0;

  return (
    <Link to={`/products/${product.productId}`} className="product-card">
      <img
        className="product-card__thumb"
        src={product.thumbnailUrl ?? '/placeholder.svg'}
        alt={product.name}
        loading="lazy"
      />
      <div className="product-card__body">
        <div className="product-card__brand">
          {product.brand}
          {product.volume ? ` · ${product.volume}` : ''}
        </div>
        <div className="product-card__name">{product.name}</div>

        <div className="price-row">
          {discounted && <span className="discount-rate">{product.discountRate}%</span>}
          <span className="price">{formatWon(product.sellingPrice)}</span>
          {discounted && <span className="price--strike">{formatWon(product.price)}</span>}
        </div>

        <div className="rating-line">
          <span className="stars">{stars(Math.round(product.ratingAverage))}</span>{' '}
          {product.ratingAverage.toFixed(1)} ({product.reviewCount})
          {product.status === 'SOLD_OUT' && <span className="badge badge--danger" style={{ marginLeft: 6 }}>품절</span>}
        </div>
      </div>
    </Link>
  );
}
